import Vue from 'vue'
import ComponentTypes, { DEFAULT, MEDIA } from './components/ComponentTypes'

export const COMPONENT_IDENTIFIER = 'id'
export const SLOT_ATTRIBUTE_IDENTIFIER = 'data-slot'
export const VUE_SLOT_ATTRIBUTE_IDENTIFIER = 'slot'


export const MOUNT_ID = 'pageContainer'
export const MOUNT_HTML_ID = `#${MOUNT_ID}`

const retrieveNodeIdentifier = (node) => {
    let attribute = node.attributes.getNamedItem(COMPONENT_IDENTIFIER)
    if (attribute) {
        return attribute.value
    }

    return undefined
}

const cloneAttributes = (element, sourceNode) => {
    let attr;
    let attributes = Array.prototype.slice.call(sourceNode.attributes);
    while(attr = attributes.pop()) {
        element.setAttribute(attr.nodeName, attr.nodeValue);
    }
}

const buildComponent = (componentIdentifier, node, componentData) => {
    let mapping = ComponentTypes
    let id = retrieveNodeIdentifier(node)

    let componentConfig = {}

    // Make sure that node has an identifier
    if (!id) {
        return undefined
    }

    if (!componentData) {
        return {component: mapping[DEFAULT], config: componentConfig}
    }

    let componentType = componentData.type? componentData.type : DEFAULT

    // If component does not exist
    if (!mapping[componentType]) {
        return undefined
    }

    // Add component config
    componentConfig = componentData.config

    // Add component identifier
    let component = {...mapping[componentType], componentIdentifier}

    return {component, config: componentConfig}
}

const replaceWrapperWithComponent = (id, component, initalDocument) => {
    if (!id) {
        return
    }

    // Always re-lookup element as to find children components as well
    // even if they have been moved to a new parent
    let htmlElement = initalDocument.getElementById(`${id}`)

    if (!htmlElement) {
        return
    }

    // Create the document fragment
    const frag = initalDocument.createDocumentFragment();

    // Fill it with what's in the source element
    while (htmlElement.firstChild) {
        frag.appendChild(htmlElement.firstChild);
    }

    // Create the new element
    // Empty the document fragment into it
    component.appendChild(frag);

    // Replace the source element with the new element on the page
    htmlElement.parentNode.replaceChild(component, htmlElement);
}

const retrieveComponentData = (key, data) => {
    return data[key]
}

const findSlots = (element) => {
    return element.querySelectorAll(`[${SLOT_ATTRIBUTE_IDENTIFIER}]`)
}

const findComponentWrappers = (document, componentData) => {
    return Object.keys(componentData)
                 .map((id) => document.querySelector('#' + id)) // TODO Change to querySelector with multiple ids?
                 .filter(element => element)
}

/**
 *  Parses a html document and returns a new html document with all component wrappers
 *  replaced with components as well as the components themselves.
 *  @param HTMLDocument document
 *  @param Object pageData
 *  @return object
 **/
export const build = (document, componentsData) => {

    let components = {}
    let initalDocument = document.cloneNode(true)
    let initalDom = initalDocument.getElementById(MOUNT_ID)

    let componentWrappers = findComponentWrappers(initalDocument, componentsData)

    for (let i = 0; i < componentWrappers.length; i++) {
        let wrapper = componentWrappers[i]
        let id = wrapper.id
        let component = document.createElement('component')
        // let componentIdentifier = `c_${i}`
        let componentIdentifier = `${id}`
        let nodeIdentifier = retrieveNodeIdentifier(wrapper)
        let componentData = retrieveComponentData(nodeIdentifier, componentsData)

        cloneAttributes(component, wrapper)

        component.setAttribute('v-bind:is', `components.${componentIdentifier}.component`)
        component.setAttribute('original-tag', wrapper.tagName)
        component.setAttribute('data-component-identifier', componentIdentifier)

        let currentComponent = buildComponent(componentIdentifier, component, componentData)

        if (!currentComponent) {
            continue
        }

        components[componentIdentifier] = currentComponent

        replaceWrapperWithComponent(id, component, initalDocument)
    }

    findSlots(initalDocument).forEach((element) => {
        element.setAttribute(VUE_SLOT_ATTRIBUTE_IDENTIFIER, element.getAttribute(SLOT_ATTRIBUTE_IDENTIFIER))
    })

    return {dom: initalDom, components}
}

/**
 *  Store getter for retrieving a specific component's config
 *  @param id string
 *  @param key string
 *  @return object | undefined
 **/
export const getComponentData = (state) => (id, key) => {
    let data =  state.components[id]? state.components[id] : {}
    let config = data.config? data.config : {}

    // Find specific key if given
    if (key) {
        return config[key]? config[key] : undefined
    }

    return config
}

export const removeDynamicComponents = (document, dom, components) => {
    let found = []

    findComponentWrappers(dom, components).forEach((element) => {
        let identifier = retrieveNodeIdentifier(element)
        let component = components[identifier]
        found.push(identifier)

        switch(component.type) {
            case MEDIA:
                const frag = document.createDocumentFragment();
                const slots = findSlots(element)

                slots.forEach((element) => {
                    frag.appendChild(element)
                })

                element.innerHTML = ''
                element.appendChild(frag)

                break;
            default:
                //element.innerHTML = ''
        }
    })

    // TODO FIX
    const deleteComponent = (identifier) => {
        Vue.delete(components, identifier)
    }

    const filterFoundComponents = (identifier) => { found.indexOf(identifier) > -1 }

    // Remove component data for missing components

    Object.keys(components)
          .filter(filterFoundComponents)
          .map(deleteComponent)


    return dom
}

export default build